import { FC } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Login } from "@gisce/oficina-virtual-components";
import { ContractationButtons } from "../NavigationMenu/Header/CustomItems/ContractationButtons";
import { Add } from "@mui/icons-material";
import { RootState } from "@/store";
import useCredentials from "../Authentication/hooks/useCredentials";
import { useSettingsContext } from "../Settings/hooks/useSettingsContext";
import ServerElementsWithoutActions from "../ServerElements/components/ServerElementsWithoutActions";
import { Box, Divider, Typography } from "@mui/material";



const LoginView: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Settings = useSettingsContext();
  const { loginCredentials } = useCredentials();
  const { 
    isAuthenticating,
    status,
    statusCode
  } = useSelector((state: RootState) => state.auth);
  const loginType = useSelector((state: RootState) => state.auth.type);

  const handleSignUp = () => {
    navigate(t('common:url.activate'));
  };

  const handleReset = () => {
    navigate(t('common:url.resetPassword'));
  };

  const handleLogin = (user: string, password: string) => {
    loginCredentials({user, password});
  };

  const getErrorMessage = () => {
    switch(statusCode) {
      case 401:
        return t('common:text.login_view_message_error_login');
      case 403:
        return t('common:text.login_view_message_error_login');
      
      default: 
        return t('common:text.login_view_message_error_login');
    }
  }

  return (
    <>
      <Login
        alertProps={
          loginType === "USER_AND_PASSWORD" &&
          status === "error" ? 
          {
            severity: "error", 
            label: getErrorMessage()
          } 
          : undefined
        }
        signUp={Settings?.features?.signup}
        onLogin={handleLogin}
        onSignUp={handleSignUp}
        onReset={handleReset}
        loading={isAuthenticating}
      />
      {Settings?.features?.showContractationOnLogin && (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', margin: '0 20px 30px', gap: 2 }}>
            <Divider sx={{ flex: 1 }} />
            <Typography variant="caption" color="text.secondary">{t('common:text.or')}</Typography>
            <Divider sx={{ flex: 1 }} />
          </Box>
          <Box sx={{ textAlign: 'center', margin: '0 20px 20px 20px'}}>
            <ContractationButtons
              startIcon={<Add />}
              label={t('common:text.home_contract_create_title')}
              fullWidth={true}
              variant="outlined"
            />
          </Box>
        </>
      )}
      <ServerElementsWithoutActions groupName="Login" />
    </>
  );
};

export default LoginView;
